module.exports = __webpack_public_path__ + "img/sobre.7218fccc.webp";